const INTERVENTION_ZONE_CODE_LENGTHS = new Set([2, 3, 5]);

export const formatCityName = (cityName = "") =>
  cityName
    .trim()
    .toLocaleLowerCase("fr-FR")
    .replace(/(^|[^\p{L}])\p{L}/gu, (letter) =>
      letter.toLocaleUpperCase("fr-FR")
    );

export const formatPostalEntryLabel = ({code_postal, nom_de_la_commune}) =>
  `${code_postal} - ${formatCityName(nom_de_la_commune)}`;

export const isValidInterventionZoneCode = (code = "") =>
  INTERVENTION_ZONE_CODE_LENGTHS.has(code.trim().length);

export const normalizePostalSearch = (value = "") =>
  value
    .trim()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLocaleLowerCase("fr-FR");
